import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-next",
  "use": "icon-next-usage",
  "viewBox": "0 0 65 14",
  "content": "<symbol viewBox=\"0 0 65 14\" fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-next\">\r\n<rect x=\"64.6338\" y=\"13.33\" width=\"64.6338\" height=\"1.79538\" transform=\"rotate(-180 64.6338 13.33)\" fill=\"currentColor\" />\r\n<rect x=\"63.1599\" y=\"13.33\" width=\"17.0561\" height=\"1.79538\" transform=\"rotate(-135 63.1599 13.33)\" fill=\"currentColor\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol